export default __webpack_public_path__ + "static/media/ketoicecream@3x.c57c2bcf.jpg";